/* COMMUTATEUR D'APERCU — chantier « option 3 editoriale », 08/09/2026.
 *
 * Pourquoi par PERSONNE et non par module : activer la nouvelle mise en page
 * sur un seul module ferait cohabiter deux designs en production. Un apprenant
 * qui enchaine deux modules verrait deux mises en page — exactement le reproche
 * de Nawal, « la position varie et perd le user ». On introduirait la maladie
 * pour tester le remede.
 *
 * Ici, seul celui qui ouvre le lien voit la nouvelle version, sur TOUS les
 * modules — ce qui est precisement ce qu'il faut pour juger une coherence.
 * Personne d'autre ne voit quoi que ce soit changer.
 *
 *   ...?apercu=edito   active et memorise dans CE navigateur
 *   ...?apercu=0       desactive
 *
 * ⚠️ Lu UNE SEULE FOIS au chargement du module, volontairement : la valeur ne
 * doit pas changer en cours de parcours, sinon la mise en page sauterait d'un
 * ecran a l'autre.
 * ⚠️ `localStorage` peut LEVER une exception, pas seulement renvoyer null :
 * navigation privee, cookies tiers bloques, iframe cloisonnee. D'ou le
 * try/catch, sans lequel un lecteur entier tomberait en ecran blanc.
 */
/* ⛔ VUE EDITORIALE SUPPRIMEE — arbitrage d'Hicham, 21/09/2026.
 *
 * Le mode editorial etait l'« option 3 editoriale » du 08/09 : image en pleine
 * hauteur sur grand ecran et titres agrandis, poses derriere un interrupteur
 * par personne. Il est abandonne, et pour une raison qui se verifie :
 * IL CONTREDIT LA MAQUETTE. Les planches Figma donnent un conteneur d'image
 * cadre a 480 x 600 et la typographie standard. La branche NON editoriale EST
 * donc la maquette ; l'autre est une piste ecartee.
 *
 * Le drapeau est mis a `false` EN DUR plutot que supprime d'un coup : plus de
 * trente branches ternaires en dependent dans neuf formats, et choisir a la
 * main la bonne branche trente fois est une occasion de se tromper trente fois.
 * A `false`, elles retombent TOUTES mecaniquement sur la valeur non editoriale.
 * Le comportement est donc corrige sans risque, et le retrait physique du code
 * mort se fait ensuite, a comportement constant.
 *
 * Disparaissent avec lui : `?apercu=edito`, `?apercu=0`, `?apercuPreview=` et
 * la cle localStorage `risingup.apercu.edito`. Plus rien n'est memorise dans le
 * navigateur, donc plus personne ne peut regarder un rendu sans savoir lequel.
 */
export const APERCU_EDITO = false

/* LE CHAPO — premier bloc de texte, plus grand que le reste.
 *
 * ⛔ NE PAS reconstruire le texte depuis le HTML pour en mesurer la longueur.
 * Le 04/08/2026, une extraction par expression reguliere a produit 175 fausses
 * coquilles sur hstories.fr : remplacer les balises par une espace colle des
 * ponctuations, les remplacer par rien colle des mots. La lecon vaut ici, ou
 * `&nbsp;` compte pour six caracteres bruts et un seul a l'ecran.
 * On demande donc au NAVIGATEUR, qui est le seul analyseur juste : `textContent`
 * rend le texte affiche, entites resolues et balises ecartees.
 *
 * Le garde-fou est indispensable. Mesure sur le catalogue, 730 ecrans de texte :
 * 411 commencent par un bloc court, les 319 autres par un pave. Sans borne, un
 * paragraphe de 400 mots passerait en gros corps — pire que l'existant.
 */
export const CHAPO_MIN = 20
export const CHAPO_MAX = 200

export const marquerChapo = (racine) => {
  if (!racine || typeof racine.querySelector !== "function") return
  /* ⚠️ Viser un vrai PARAGRAPHE, pas le premier element venu. `querySelector
     ("p, div")` tombait sur le conteneur du champ editable, dont le texte est
     l'integralite du contenu : mesure > 200 caracteres, donc jamais de chapo.
     Sans paragraphes dans le contenu, il n'y a rien a distinguer : on sort. */
  const premier = racine.querySelector("p")
  if (!premier) return
  const n = (premier.textContent || "").trim().length
  premier.setAttribute("data-chapo", n >= CHAPO_MIN && n <= CHAPO_MAX ? "oui" : "non")
}
